import * as moment from 'moment';
import { DataIdConverterFactory, DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { NatureControle } from './nature-controle.model';
import { ObjetControle } from './objet-controle.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { Activite } from '../../habilitation/models/activite.model';
import { DateConverter, DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { Operateur } from '../../intervenant/models/operateur.model';
import { OperateurInformationsDomaine } from '../../intervenant/models/operateur-informations-domaine.model';
import { Produit } from '../../habilitation/models/produit.model';
import { TypeControle } from './type-controle.model';
import { StatutControle } from './statut-controle.model';

export class Controle {
    static jsonMap = {
        id: 'id',
        nature: { key: 'idNature', converter: new (DataIdConverterFactory.build(NatureControle, 'naturesControle'))() },
        objet: { key: 'idObjet', converter: new (DataIdConverterFactory.build(ObjetControle, 'objetsControle'))() },
        statut: { key: 'idStatut', converter: new (DataIdConverterFactory.build(StatutControle, 'statutsControle'))() },
        numeroControle: 'numeroControle',
        idAgent: 'idAgent',
        idOperateur: 'idOperateur',
        idIntervenant: 'idIntervenant',
        idMouvement: 'idMouvement',
        idStatut: 'idStatut',
        idEchantillon: 'idEchantillon',
        cahiers: { key: 'idCahierList', converter: new (DataIdArrayConverterFactory.build(Cahier, 'cahiers'))() },
        activites: { key: 'idActiviteList', converter: new (DataIdArrayConverterFactory.build(Activite, 'activites'))() },
        codeProduitList: 'codeProduitList',
        dateButoir: { key: 'dateButoir', converter: new DateConverter() },
        dateControle: { key: 'dateControle', converter: new DateConverter() },
        typeControle: { key: 'idTypeControle', converter: new (DataIdConverterFactory.build(TypeControle, 'typesControle'))() },
        numeroEchantillon: 'numeroEchantillon',
        numeroCommission: 'numeroCommission',
        numeroJury: 'numeroJury',
        numeroAnonymat: 'numeroAnonymat',
        idLaboratoire: 'idLaboratoire',
        libelleLaboratoire: 'libelleLaboratoire',
        dateEnvoiLaboratoire: { key: 'dateEnvoiLaboratoire', converter: new DateConverter() },
        nbManquement: 'nbManquement',
        volume: 'volume',
        logement: 'logement',
        lot: 'lot',
        numeroLot: 'numeroLot',
        libelleCahier: 'libelleCahier',
        libelleProduit: 'libelleProduit',
        libelleMouvement: 'libelleMouvement',
        millesime: 'millesime'
    };

    id: number;

    nature: NatureControle;
    objet: ObjetControle;
    statut: StatutControle;

    numeroControle: string;

    idAgent: number;
    idOperateur: number;
    operateur: Operateur;
    infosOperateur: OperateurInformationsDomaine[] = [];

    idIntervenant: number;
    idMouvement: number;
    idStatut: number;
    idEchantillon: number;

    cahiers: Cahier[] = [];
    activites: Activite[] = [];

    codeProduitList: string[] = [];
    produits: Produit[] = [];

    dateButoir: moment.Moment;
    dateControle: moment.Moment;

    typeControle: TypeControle;

    numeroEchantillon: string;
    numeroCommission: string;
    numeroJury: string;
    numeroAnonymat: string;

    idLaboratoire: number;
    libelleLaboratoire: string;
    dateEnvoiLaboratoire: moment.Moment;

    nbManquement: number;
    volume: number;
    logement: string;
    lot: string;
    numeroLot: string;

    libelleCahier: string;
    libelleProduit: string;
    libelleMouvement: string;

    millesime: number;

    numeroExpertise: number;
    numeroPassage: number;

    // Leurres
    idLeurre: number;
    isLeurre: boolean;
    raisonSociale: string;
}
